module.exports = __webpack_public_path__ + "fonts/HSESlab-Regular.4736f25.otf";